const hasSymbol = typeof Symbol === "function";
const webpackQueues = hasSymbol ? Symbol("webpack queues") : "__webpack_queues__";
const webpackExports = hasSymbol ? Symbol("webpack exports") : "__webpack_exports__";
const webpackError = hasSymbol ? Symbol("webpack error") : "__webpack_error__";

const resolveQueue = (queue) => {
	if(queue?.d < 1) {
		queue.d = 1;
		queue.forEach((fn) => (fn.r--));
		queue.forEach((fn) => (fn.r-- ? fn.r++ : fn()));
	}
}
const wrapDeps = (deps) => (deps.map((dep) => {
	if(dep !== null && typeof dep === "object") {

		if(dep[webpackQueues]) return dep;
		if(dep.then) {
			const queue = [];
			queue.d = 0;
			dep.then((r) => {
				obj[webpackExports] = r;
				resolveQueue(queue);
			}, (e) => {
				obj[webpackError] = e;
				resolveQueue(queue);
			});
			const obj = {};

			obj[webpackQueues] = (fn) => (fn(queue));
			return obj;
		}
	}
	const ret = {};
	ret[webpackQueues] = x => {};
	ret[webpackExports] = dep;
	return ret;
}));
__webpack_require__.a = (module, body, hasAwait) => {
	let queue;
	hasAwait && ((queue = []).d = -1);
	const depQueues = new Set();
	const exports = module.exports;
	let currentDeps;
	let outerResolve;
	let reject;
	const promise = new Promise((resolve, rej) => {
		reject = rej;
		outerResolve = resolve;
	});
	promise[webpackExports] = exports;
	promise[webpackQueues] = (fn) => (queue && fn(queue), depQueues.forEach(fn), promise["catch"](x => {}));
	module.exports = promise;
	const handle = (deps) => {
		currentDeps = wrapDeps(deps);
		let fn;
		const getResult = () => (currentDeps.map((d) => {

			if(d[webpackError]) throw d[webpackError];
			return d[webpackExports];
		}))
		const promise = new Promise((resolve) => {
			fn = () => (resolve(getResult));
			fn.r = 0;
			const fnQueue = (q) => (q !== queue && !depQueues.has(q) && (depQueues.add(q), q && !q.d && (fn.r++, q.push(fn))));
			currentDeps.map((dep) => (dep[webpackQueues](fnQueue)));
		});
		return fn.r ? promise : getResult();
	}
	const done = (err) => ((err ? reject(promise[webpackError] = err) : outerResolve(exports)), resolveQueue(queue))
	body(handle, done);
	queue?.d < 0 && (queue.d = 0);
};